(function AcceptCookies($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		$('#accept_cookies').click(function acceptClicked(e) {
			var website_id    = $(this).data('website_id'),
			    date_accepted = $(this).data('current_date');

			e.preventDefault();

			Cookies.set('cp_cookies_accepted', website_id + '|' + date_accepted, {
				expires: 3650,
				path   : '/'
			});

			$('#cookie_notice').fadeOut('slow');
		});
	});
}(jQuery, window.Adzuki || {}));
